import { render, staticRenderFns } from "./InfoAlert.vue?vue&type=template&id=525db732&"
import script from "./InfoAlert.vue?vue&type=script&lang=js&"
export * from "./InfoAlert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports